import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 挂载全局组件
import Public from '@/components'
Vue.use(Public)
Vue.config.productionTip = false
import {
  COMMON,
  api
} from "./config/index";
import '@/assets/index.less'
// 挂载封装的API
Vue.prototype.$api = api
// 挂载COMMON
Vue.prototype.$COMMON = COMMON
// 引入组件库-vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
// 使用剪贴板
import VueClipboard from 'vue-clipboard2' 
Vue.use(VueClipboard)
// 引入全局filter
import * as filters from './plugins/filter'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

// 两端的npm包
import {utils,native} from 'zhibo-lynn'
Vue.prototype.$UTILS = utils
Vue.prototype.$NATIVE = native
// cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import 'intersection-observer'
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
